__turbopack_context__.v({
  "control": "CarouselSection-module-scss-module__Apo0aG__control",
  "controls": "CarouselSection-module-scss-module__Apo0aG__controls",
  "indicator": "CarouselSection-module-scss-module__Apo0aG__indicator",
  "indicators": "CarouselSection-module-scss-module__Apo0aG__indicators",
  "root": "CarouselSection-module-scss-module__Apo0aG__root",
  "slide": "CarouselSection-module-scss-module__Apo0aG__slide",
});
